<template>
  <section id="main" class="container-main" v-if="init">
    <Header :open-menu-modal="openMenuModal"/>
    <div class="container-inner">

      <div class="banner animation-container" ref="bannerSection">
        <div class="banner-title">
          <h3 class="fade-in-text nunito-font pc" :class="{ visible: isVisible }">
            Only Jesus, Only the Gospel
          </h3>
          <h3 class="fade-in-text nunito-font mobile" :class="{ visible: isVisible }">
            Only Jesus,<br>
            Only the Gospel
          </h3>
          <p class="fade-in-text" :class="{ visible: isVisible }">
            "오직 성령이 너희에게 임하시면 너희가 권능을 받고 예루살렘과 온 유대와 사마리아와 땅끝까지 이르러 내 증인이 되리라"<br>
            <span>- Acts 1:8 -</span>
          </p>
        </div>
        <div class="overlay"></div>
      </div>

      <Intro :intro-image-scale="introImageScale" />
      <ResentSermon :sermon-image-scale="sermonImageScale" />

      <section class="gallery container" ref="gallerySection">
        <div class="gallery-inner clearfix">
          <div class="title-box" ref="galleryTitle">
            <p class="deco-text">Only Grace.</p>
            <h2 class="do-hyeon-regular">AXIS Gallery</h2>
            <p class="sub-font">주 안에서 함께하는, 하나되는 순간들</p>
            <p class="bible-verse">
              날마다 마음을 같이 하여 성전에 모이기를 힘쓰고<br>
              집에서 떡을 떼며 기쁨과 순전한 마음으로 음식을 먹고<br>
              <span>- Acts 2:46 -</span><br>

            </p>
            <div class="button-container left-align">
              <router-link to="/gallery">
                <button type="button">
                  갤러리 더보기
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none"><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 12-6-6m6 6-6 6m6-6H5"/></svg>
                </button>
              </router-link>
            </div>
          </div>
          <div class="content-box">
            <gallery-list :gallery-list="galleryData" :select-gallery="selectGallery" />
          </div>
        </div>
      </section>

      <aside class="aside">
        <div class="aside-inner">
          <div class="title-box" ref="asideTitle">
            <h2 class="do-hyeon-regular pc">
              나를 믿는 자는 성경에 이름과 같이 그 배에서 생수의 강이 흘러나리라
            </h2>
            <h2 class="do-hyeon-regular mobile">
              나를 믿는 자는 성경에 이름과 같이<br>
              그 배에서 생수의 강이 흘러나리라
            </h2>
            <p class="sub-font">
              - 요한복음 7:38 -
            </p>
          </div>
        </div>
      </aside>

      <Map />
    </div>
    <Footer/>

    <GalleryImageModal v-if="galleryImageView && selectedGallery" :selected-gallery="selectedGallery" :close-btn="closeImageModalBtn" />
    <MenuModal v-if="menuModalView" :open-menu-modal="openMenuModal" :close-menu-modal="closeMenuModal" />
  </section>
</template>

<script>

import Header from "@/components/core/Header.vue";
import Footer from "@/components/core/Footer.vue";
import GalleryList from "@/views/gallery/components/GalleryList.vue";
import Intro from "@/views/components/Intro.vue";
import ResentSermon from "@/views/components/ResentSermon.vue";
import Map from "@/views/components/Map.vue";
import GalleryImageModal from "@/views/modal/GalleryImageModal.vue";
import MenuModal from "@/views/modal/MenuModal.vue";
import {fetchBoardData, fetchBoardOne} from "@/services/api/boardApi";

export default {
  name: "Main",
  components: {MenuModal, GalleryImageModal, Map, ResentSermon, Intro, GalleryList, Footer, Header},
  data() {
    return {
      init: false,
      isVisible: false,
      cardWidth: 300,
      introImageScale: 1,
      sermonImageScale: 1,
      galleryImageView: false,
      selectedGallery: null,
      menuModalView: false,
      galleryData: [],
    }
  },
  created() {

    this.init = true;

  },
  mounted() {

    this.loadGalleryData();

    // 컴포넌트가 마운트된 후에 애니메이션을 트리거
    this.showText();
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -150px 0px',  // 뷰포트 하단에서 200px 지나야만 트리거
      threshold: 0  // 요소의 30%가 보일 때 트리거
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 요소가 보이면 isVisible을 true로 설정
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const banner = this.$refs.bannerSection;

    // 페이지가 로드된 후에 애니메이션 클래스를 추가
    window.addEventListener('load', () => {
      banner.classList.add('zoom');
    });

    observer.observe(this.$refs.bannerSection);
    observer.observe(this.$refs.galleryTitle);
    observer.observe(this.$refs.asideTitle);

  },

  methods: {
    showText() {
      setTimeout(() => {
        this.isVisible = true;
      }, 200)
    },

    async loadGalleryData() {
      try {
        const response = await fetchBoardData(['GALLERY'], 0, 8,
            'created_at,DESC');
        this.galleryData = response.data;
      } catch (err) {
        console.log(err)
      }
    },

    async loadGalleryOne(id) {
      try {
        return await fetchBoardOne(id);
      } catch (err) {
        console.log(err)
      }
    },

    handleIntersect(entries) {

      entries.forEach((entry) => {

        // sermon 이미지
        if (entry.target.id === 'sermonImage' && entry.isIntersecting) {
          setTimeout(() => {
            this.sermonImageScale = 1.05; // 인트로 이미지 확대
          }, 100); // 이동 애니메이션 후 확대 애니메이션 시작 (0.5초 후)
        }
      });
    },

    async selectGallery(id) {
      this.selectedGallery = await this.loadGalleryOne(id);
      this.galleryImageView = true;
    },

    closeImageModalBtn() {
      this.galleryImageView = false;
    },

    openMenuModal() {
      this.menuModalView = true;
    },

    closeMenuModal() {
      this.menuModalView = false;
    }

  }
}

</script>

<style scoped lang="scss">

.animation-container {
  opacity: 0;
  transition: opacity 1s ease-out;
}

.animation-container.visible {
  opacity: 1;
}

.sub-font {
  font-style: normal;
  margin-top: 25px;
  margin-bottom: 20px;
  font-weight: 400;
  color: #555;
  font-size: 17px;
}

.button-container {

  display: flex;
  justify-content: center; /* 수평 중앙 정렬 */
  align-items: center; /* 수직 중앙 정렬 */
  height: 100%; /* 필요에 따라 부모 컨테이너의 높이를 설정 */
  margin-top: 60px;

  &.left-align {
    justify-content: left;
  }

  button {
    box-sizing: border-box;
    padding: 15px 20px;
    border: 1px solid #eee;
    border-radius: 100px;
    font-size: 14px;
    background-color: #fff;

    cursor: pointer;
    display: flex;
    align-items: center; /* 버튼 안의 텍스트와 아이콘 수직 중앙 정렬 */
    justify-content: center; /* 버튼 안의 텍스트와 아이콘 수평 중앙 정렬 */

    transition: all 0.3s ease;

    svg {
      width: 20px;
      height: 20px;
      margin-left: 10px;

      path {
        stroke: #00ade3;
      }
    }

    &:hover {
      background-color: #f0f0f0; /* 호버 효과 색상 */

    }

    &:active {
    }
  }
}

.container-main {

  position: relative;

  .container-inner{

    .banner {

      display: flex;
      justify-content: center; /* 수평 가운데 정렬 */
      align-items: center; /* 수직 가운데 정렬 */

      position: relative;
      width: 100%;
      height: 920px;
      overflow: hidden;

      background-repeat: no-repeat;
      background-size: 2560px;
      background-position: center center;
      background-image: url("../assets/resized/role-technology-enhancing-christian-worship-through-raised-hands-church-services-concept-christian-worship-technology-church-raised-hands-enhancing-worship-spiritual-practices (1).jpg");
      //background-image: url("../assets/axis/retreat/2025/winter/KakaoTalk_20250209_191020310.jpg");
      //background-image: url("../assets/axis/retreat/2025/winter/KakaoTalk_20250209_191020310_02.jpg");
      background-attachment: fixed;
      transition: background-size 5s ease; /* 배경 이미지 확대 애니메이션 */
      background-position: top;
      background-position-y: -100px;

      &.zoom {
        background-size: 2800px; /* 확대된 배경 크기 */
        //transform: scale(1.2); /* 확대 크기 */
      }

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.15); /* 검은색 오버레이 */
      }

      .banner-title {
        position: relative;
        z-index: 9;
        text-align: center;
        color: #fff;
        width: 1280px;
        box-sizing: border-box;
        padding: 10px;
        margin: 0 auto;
        line-height: 1.4;

        h3 {
          font-weight: 700;
          font-size: 42px;

          &.pc {
            display: block;
          }

          &.mobile {
            display: none;
          }

        }

        p {
          margin-top: 20px;
          font-weight: 200;
          font-size: 16px;

          span {
            font-style: italic;
            display: inline-block;
            margin-top: 5px;
          }
        }
      }

    }

    .gallery {
      box-sizing: border-box;
      padding-top: 140px;
      padding-bottom: 140px;
      //background-color: #f0f4f7;

      .gallery-inner {

        max-width: 1280px;
        width: 100%;
        margin: 0 auto;

        .title-box {
          position: relative;
          z-index: 1;
          float: left;
          width: 100%;
          text-align: left;
          box-sizing: border-box;
          padding: 10px;
          padding-top: 40px;
          line-height: 1.5;
          opacity: 0;
          transform: translateX(-200px);
          transition: all .3s ease-out;

          h2 {
            position: relative;
          }

          .button-container {
            margin-top: 40px;
          }

          .deco-text {
            position: absolute;
            top: -5px;
            left: 10px;
            font-family: "Montserrat", sans-serif;
            font-optical-sizing: auto;
            font-weight: 900;
            color: #f3f3f3;
            //color: #ffd3d3;
            font-size: 60px;
            z-index: 0;
          }

          &.visible {
            opacity: 1;
            transform: translateX(0);
          }

          h3 {

          }

          .bible-verse {
            font-size: 15px;
            color: #888;

            span {
              display: inline-block;
              margin-top: 5px;
              font-style: italic;
            }
          }
        }

        .content-box {
          float: left;
          width: 100%;
        }
      }
    }

    .aside {
      background-position: center center;
      background-image: url("../assets/resized/OMSZ940.jpg");
      background-repeat: no-repeat;
      background-color: rgba(0, 0, 0, 0.05);
      background-blend-mode: color;
      text-align: left;
      width: 100%;
      height: 400px;
      background-attachment: fixed;
      background-size: 2560px;
      background-position-y: -100px;

      .aside-inner {
        max-width: 1280px;
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        margin: 0 auto;
        padding-top: 120px;

        .title-box {
          color: #333;
          line-height: 1.4;
          opacity: 0;
          transition: all .5s ease-out;
          transform: translateY(40px);

          &.visible {
            opacity: 1;
            transform: translateY(0);
          }

          h2 {
            font-size: 28px;

            &.pc {
              display: block;
            }

            &.mobile {
              display: none;
            }

          }

          p {
            font-style: italic;
            color: #333;
            margin-top: 10px;
          }
        }
      }
    }

    .family-site-box {
      width: 100%;
      box-sizing: border-box;
      border-top: 1px solid #ddd;

      .family-site-wrapper {
        max-width: 1280px;
        box-sizing: border-box;
        margin: 0 auto;

        .family-site-item {
          font-size: 15px;
          float: left;
          box-sizing: border-box;
          padding: 20px 10px;

          :first-child {
            margin-right: 10px;
          }

          a {
            display: flex;
            align-items: center;

            i {
            }
          }
        }
      }
    }

  }

}

@media screen and (max-width: 1512px) {


  .container-main .container-inner .banner {
    height: 70vh;
    background-position: top;
    box-sizing: border-box;
    padding: 15px;
    //background-size: cover;
    background-size: 2200px;
  }

  .container-main .container-inner .banner.zoom {
    background-size: 2400px;
  }

  .container-main .container-inner .gallery .gallery-inner {
    box-sizing: border-box;
    padding: 15px;
  }

  .container-main .container-inner .gallery .gallery-inner .title-box .deco-text {
    font-size: 55px;
    top: -2px;
  }

  .container-main .container-inner .aside .aside-inner {
    padding-left: 25px;
    padding-right: 25px;
  }

  .container-main .container-inner .family-site-box .family-site-inner {
    box-sizing: border-box;
    padding: 0 15px;
  }

  .container-main .container-inner .family-site-box .family-site-inner .family-site-wrapper .family-site-item:first-child {
    padding-right: 0;
    margin-right: 0;
  }

}

@media screen and (max-width: 1200px) {
  .container-main .container-inner .gallery .gallery-inner .title-box .deco-text {
    font-size: 42px;
    top: 8px;
  }
}

@media screen and (max-width: 768px) {

  .map .map-inner .map-wrapper .map-list.text .title-box .sub-font {
    font-size: 24px;
  }

  .container-main .container-inner .banner {
    height: 75vh;
    background-position: top;
    box-sizing: border-box;
    padding: 15px;
    background-size: 1600px;
    background-position-x: calc(50% + 20px);
  }

  .container-main .container-inner .banner.zoom {
    background-size: 1800px;

  }

  .container-main .container-inner .banner .banner-title {
    margin-top: 70px;
  }

  .container-main .container-inner .banner .banner-title h3.pc {
    display: none;

  }

  .container-main .container-inner .banner .banner-title h3.mobile {
    display: block;
    font-size: 36px;
  }

  .container-main .container-inner .gallery {
    padding-top: 60px;
    padding-bottom: 40px;
  }

  .container-main .container-inner .gallery .gallery-inner .content-box {
    padding-top: 40px;
  }

  .container-main .container-inner .aside {
    height: 300px;
  }

  .container-main .container-inner .aside .aside-inner {
    padding-top: 100px;
  }

  .container-main .container-inner .aside .aside-inner .title-box h2.pc {
    display: none;
  }

  .container-main .container-inner .aside .aside-inner .title-box h2.mobile {
    display: block;
    font-size: 24px;
  }

  .container-main .container-inner .aside .aside-inner .title-box p {
    font-size: 15px;
  }


}
</style>